import 'react-app-polyfill/ie11'; // For IE 11 support
import 'react-app-polyfill/stable';
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux'
import {icons} from './assets/icons'
import Store from "./app/redux/Store";
import {I18nextProvider} from "react-i18next";
import i18n from './i18n'
import { CSpinner } from '@coreui/react';

React.icons = icons

// console.log(i18n)

ReactDOM.render(
    <Provider store={Store}>
        <I18nextProvider i18n={i18n}>
            <App/>
           <div id={"full-spinner"}  style={{display: "none"}}>
               <CSpinner
                   color="info"
                   className="center-spinner"
                   size="lg"
                   style={{display: "none"}}
               ></CSpinner>
           </div>
        </I18nextProvider>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
